/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dull_Brief_Giraffe_GazeInputs */

const fr_dull_brief_giraffe_gaze = /** @type {(inputs: Dull_Brief_Giraffe_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

/**

* @param {Dull_Brief_Giraffe_GazeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dull_brief_giraffe_gaze = /** @type {((inputs?: Dull_Brief_Giraffe_GazeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dull_Brief_Giraffe_GazeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dull_brief_giraffe_gaze(inputs)
});